<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:items-start lg:gap-7">
    <section class="grid gap-5">
      <div class="grid gap-3.5 py-2.5">
        <h3 class="text-[13px] font-medium uppercase tracking-[1px] text-[#ffaa00]">Basic settings</h3>
        <bly-native-text-field
          :value="model.name"
          label="Name"
          :error="errors.name"
          required
          @input="updateRoot('name', $event)"
        />
        <bly-native-text-field
          v-if="mode === 'create'"
          :value="model.id"
          label="ID"
          placeholder="Optional custom ID"
          @input="updateRoot('id', $event)"
        />
      </div>

      <div class="grid gap-3.5 py-2.5">
        <h3 class="text-[13px] font-medium uppercase tracking-[1px] text-[#ffaa00]">Claims</h3>
        <div class="grid gap-1">
          <span class="text-xs font-semibold text-[#dde6f3]">Access claims *</span>
          <el-cascader
            :value="model.claimsCanAccess"
            :options="claimsTree"
            :props="{ multiple: true, checkStrictly: true }"
            :show-all-levels="false"
            collapse-tags
            clearable
            class="w-full"
            @input="updateRoot('claimsCanAccess', $event)"
          />
          <span v-if="errors.claimsCanAccess" class="text-xs text-red-300">
            {{ errors.claimsCanAccess }}
          </span>
        </div>

        <div class="mt-3.5 grid gap-1">
          <span class="text-xs font-semibold text-[#dde6f3]">Edit claims *</span>
          <el-cascader
            :value="model.claimsCanEdit"
            :options="claimsTree"
            :props="{ multiple: true, checkStrictly: true }"
            :show-all-levels="false"
            collapse-tags
            clearable
            class="w-full"
            @input="updateRoot('claimsCanEdit', $event)"
          />
          <span v-if="errors.claimsCanEdit" class="text-xs text-red-300">
            {{ errors.claimsCanEdit }}
          </span>
        </div>
      </div>
    </section>

    <section class="grid gap-5">
      <div class="grid gap-3.5 py-2.5">
        <h3 class="text-[13px] font-medium uppercase tracking-[1px] text-[#ffaa00]">Provider details</h3>
        <bly-native-textarea-field
          :value="model.provider.contactDetails"
          label="Contact details"
          :rows="4"
          @input="updateProvider('contactDetails', $event)"
        />
        <bly-native-textarea-field
          :value="model.provider.instructions"
          label="Instructions"
          hint="Shown to operators in the booking preview panel."
          :rows="10"
          @input="updateProvider('instructions', $event)"
        />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ProviderPermissionForm",
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    mode: {
      type: String,
      default: "create",
    },
    claimsTree: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model() {
      return this.value;
    },
  },
  methods: {
    updateRoot(field, value) {
      this.$emit("input", {
        ...this.model,
        [field]: value,
      });
    },
    updateProvider(field, value) {
      this.$emit("input", {
        ...this.model,
        provider: {
          ...this.model.provider,
          [field]: value,
        },
      });
    },
  },
};
</script>
